// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3AfOp","header":"MergedInvoice_header__2gfaj"};